/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Page from '../../layout/Page/Page';
import Card, {
    CardActions,
    CardBody,
    CardHeader,
} from '../../components/bootstrap/Card';
import {
    CalendarTodayButton,
    CalendarViewModeButtons,
    getUnitType,
    getViews,
} from '../../components/extras/calendarHelper';
import {
    Calendar,
    momentLocalizer,
    Views,
    View as TView,
} from 'react-big-calendar';
import moment from 'moment';
import postsList, { IEventsCalendar, IPlatformProps } from './posts';
import PLATFORMS from '../dashboard/common/platformsDummyData';
import classNames from 'classnames';
import Tooltips from '../../components/bootstrap/Tooltips';

const localizer = momentLocalizer(moment);
const now = new Date();

/* POST INTERFACE */
interface IPost extends IEventsCalendar {
    platform?: IPlatformProps;
}

/* SCHEDULED POST REPRESENTATION */
const ScheduledPost = (data: { event: IPost }) => {
    const { event } = data;
    return (
        <div
            className='custom-post'
            style={{
                borderTop: '3px solid' + event.color,
            }}>
            <div className='row g-2'>
                <div className='col text-truncate'>
                    {event?.platform && (
                        <img
                            src={event?.platform.logo}
                            width='20'
                            alt={event?.platform.name}
                        />
                    )}
                    <span
                        style={{
                            marginLeft: '8px',
                            fontWeight: '600',
                            color: '#000',
                        }}>
                        {event?.title}
                    </span>
                </div>
            </div>
        </div>
    );
};

const ScheduledWeekPost = (data: { event: IPost }) => {
    const { event } = data;
    return (
        <div
            className='custom-post-week'
            style={{ borderTop: '3px solid' + event.color }}>
            <div className='d-flex' style={{ alignItems: 'center' }}>
                {event?.platform && (
                    <img
                        src={event?.platform.logo}
                        width='20'
                        alt={event?.platform.name}
                    />
                )}
                <div style={{ marginLeft: '8px' }}>
                    <span
                        style={{
                            fontWeight: '600',
                            color: '#000',
                        }}>
                        {event?.title}
                    </span>
                </div>
            </div>
        </div>
    );
};

const ScheduledDayPost = (data: { event: IPost }) => {
    const { event } = data;
    return (
        <Tooltips
            title={`${event?.name} / ${moment(event.start).format('LT')}`}>
            <div className='row g-2'>
                {event?.platform && (
                    <img
                        src={event?.platform.logo}
                        width='20'
                        alt={event?.platform.name}
                    />
                )}
                <small className='col text-truncate'>
                    {event?.platform && (
                        <img
                            src={event?.platform.logo}
                            width='20'
                            alt={event?.platform.name}
                        />
                    )}
                    {event?.name}
                </small>
            </div>
        </Tooltips>
    );
};

const SchedulePost = () => {
    const navigate = useNavigate();

    /* VIEW MODES */
    const [viewMode, setViewMode] = useState<TView>(Views.MONTH);
    const [date, setDate] = useState(new Date());
    const unitType = getUnitType(viewMode);

    /* VIEWS */
    const views = getViews();

    /* EVENTS */
    const [scheduledPosts, setScheduledPosts] = useState(postsList);
    useEffect(() => {
        setScheduledPosts(postsList);
        return () => {};
    }, []);

    /* PLATFORMS */
    const [platformsList, setPlatformsList] = useState({
        [PLATFORMS.FACEBOOK.name]: true,
        [PLATFORMS.INSTAGRAM.name]: true,
        [PLATFORMS.LINKEDIN.name]: true,
        [PLATFORMS.TWITTER.name]: true,
    });

    /* VIEW MODES */
    const handleViewMode = (e: moment.MomentInput) => {
        // @ts-ignore
        setDate(moment(e)._d);
        setViewMode(Views.DAY);
    };

    /* EVENT STYLES */
    const eventStyleGetter = (
        event: { color?: string },
        start: any,
        end: any,
        isSelected: boolean,
    ) => {
        const isActiveEvent = start <= now && end >= now;
        const isPastEvent = end < now;
        const color = isActiveEvent ? 'success' : event.color;
        return {
            className: classNames({
                [`bg-l10-${color} text-${color}`]: color,
                'border border-success': isActiveEvent,
                'opacity-50': isPastEvent,
            }),
        };
    };
    return (
        <PageWrapper title='Schedule Post'>
            <Page container='fluid'>
                <div className='row h-100'>
                    <div className='col-12'>
                        <Card stretch className='schedule-card-two'>
                            <CardBody className='schedule-card-two-body'>
                                <div className='row'>
                                    <div className='col-xl-3 col-sm-12'>
                                        <div className='left-schedule-side'>
                                            <div className='schedule-top'>
                                                <h2 className='schedule-heading'>
                                                    Scheduled Postings
                                                </h2>
                                                <p className='schedule-subheading'>
                                                    Here you find all the
                                                    upcoming posts and media you
                                                    scheduled on your platforms.
                                                </p>
                                            </div>
                                            <div className='schedule-bottom'>
                                                <div className='bottom-division'>
                                                    <h1 className='count'>2</h1>
                                                    <p className='title'>
                                                        Scheduled for today
                                                    </p>
                                                </div>
                                                <div className='bottom-division'>
                                                    <h1 className='count'>
                                                        12
                                                    </h1>
                                                    <p className='title'>
                                                        Posted this week
                                                    </p>
                                                </div>
                                                <div className='bottom-division'>
                                                    <h1 className='count'>4</h1>
                                                    <p className='title'>
                                                        Upcoming this week
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-xl-9 col-sm-12'>
                                        <div
                                            className='d-flex'
                                            style={{
                                                justifyContent: 'space-between',
                                                marginBottom: '10px',
                                            }}>
                                            <CalendarTodayButton
                                                unitType={unitType}
                                                date={date}
                                                setDate={setDate}
                                                viewMode={viewMode}
                                            />
                                            <CalendarViewModeButtons
                                                setViewMode={setViewMode}
                                                viewMode={viewMode}
                                            />
                                        </div>
                                        <div className='calendar-schedule'>
                                            <Card
                                                stretch
                                                className='calendar-card-two'>
                                                <CardBody isScrollable>
                                                    <Calendar
                                                        selectable
                                                        toolbar={false}
                                                        localizer={localizer}
                                                        events={scheduledPosts.filter(
                                                            (i) =>
                                                                i?.platform &&
                                                                platformsList[
                                                                    i.platform
                                                                        .name
                                                                ],
                                                        )}
                                                        defaultView={Views.WEEK}
                                                        views={views}
                                                        view={viewMode}
                                                        date={date}
                                                        onSelectEvent={() =>
                                                            navigate(
                                                                `../publish-post`,
                                                            )
                                                        }
                                                        onSelectSlot={() =>
                                                            navigate(
                                                                `../publish-post`,
                                                            )
                                                        }
                                                        onView={handleViewMode}
                                                        onDrillDown={
                                                            handleViewMode
                                                        }
                                                        components={{
                                                            event: ScheduledPost,
                                                            week: {
                                                                event: ScheduledWeekPost,
                                                            },
                                                            work_week: {
                                                                event: ScheduledWeekPost,
                                                            },
                                                            day: {
                                                                event: ScheduledDayPost,
                                                            },
                                                        }}
                                                        scrollToTime={
                                                            new Date(
                                                                1970,
                                                                1,
                                                                1,
                                                                6,
                                                            )
                                                        }
                                                        defaultDate={new Date()}
                                                        eventPropGetter={
                                                            eventStyleGetter
                                                        }
                                                    />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default SchedulePost;
